<template>
    <div >
        <nav-breadcrumb :menu="[{label: '余额还款收息'}]"/>
        <el-row class="xzpadd10 bg-purple">
            <data-table
                :tableData="listData"
                :columns="listColumns"
                :pageSize.sync="pageSize"
                :page.sync="page"
                :filters="filters"
                :actions="actions"
                @handleSelectionChange="handleSelectChange"
                :is-multiple-selection-show="true"
            ></data-table>
        </el-row>
        <el-dialog
            title="导出"
            :visible.sync="dialogVisible"
            width="30%">
            <el-form :model="reportForm"  ref="reportForm" label-width="150px">
                <el-row :gutter="10" class="bg-purple xamhtrpg">
                <el-col :span="12">
                    <el-form-item label="应还款月：" prop="repayDate">
                        <el-date-picker
                            v-model="repayDate"
                            value-format="yyyy-MM-01 00:00:00"
                            type="month"
                            placeholder="选择日期">
                        </el-date-picker>
                    </el-form-item>
                </el-col>
                </el-row>
            </el-form>

            <div class="tr xzmt">
                <el-button type="primary" @click="exportDoc()">导出</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import xhr from '../../utils/xhr'
    import moment from 'moment'
    import Status2CN from "../../filters/Status2CN";
    import {xmlBuildQuery} from "../../filters/CommonActions";
    import {formatMoney} from "../../filters/CommonFilters";
    export default {
        name: "RepaymentWithExcessAmountList",
        data() {
            return {
                reportForm:{},
                selectedIds:'',
                repayDate:'',
                dialogVisible:false,
                excessAmountOption:'',
                repayments:'',
                transactionStatus: this.$route.query['fi.transactionStatus'],
                page: 1,
                pageSize: 20,
                listData: {},
                listColumns: [
                    {
                        name: '序号',
                        type: 'index'
                    },
                    {
                        name: '贷款编号',
                        field: 'fi__transactionNo'
                    },

                    {
                        name: '客户姓名',
                        field: 'fi__customerName'
                    },

                    {
                        name: '贷款状态',
                        field: 'fi__transactionStatus',
                        formatter: function (r,c,v) {
                            return v=='Pending Approval'?'待审核':Status2CN('Financing_'+v)
                        }
                    },

                    {
                        name: '银行流水号',
                        field: 'de__bankRef'
                    },
                    {
                        name: '交易金额',
                        field: 'de__creditAmount',
                        formatter: function (r,c,v) {
                            if(v)
                                return formatMoney(v)
                        }
                    },
                    {
                        name: '网银交易日期',
                        field: 'de__txDate',
                        formatter: function (r,c,v) {
                            if(v)
                                return moment(v).format('YYYY-MM-DD')
                        }
                    },


                    {
                        name: '本期余额',
                        field: 're__excessAmount',
                        formatter: function (r,c,v) {
                            return formatMoney(v)
                        }
                    },
                    {
                        name: '处理方式',
                        field: 're__excessAmountOption',
                        formatter: function (r,c,v) {
                            return Status2CN(v)
                        }
                    },
                   /* {
                        label: '操作',
                        width: '180',
                        opts: [
                            {
                                label: '处理',
                                class: 'el-icon-finished',
                                clickHandler: (index, row)=> {
                                    this.excessAmountOption = 'Profit'
                                    this.dialogVisible = true
                                    this.repayments = row.re__repaymentId
                                }
                            },
                        ]
                    }*/
                ],
                filters: {
                    labelWidth: '150px',
                    form: {
                        de__txDate:[],
                        fi__customerName:'',
                        plan__repayDate:'',
                    },
                    rules: {
                        de__txDate:{
                            required:true,
                            message: '不能为空'
                        }
                    },
                    columns: [
                        {
                            label: '网银交易日期',
                            component: 'date-range-picker',
                            field: 'de__txDate',
                            op: ['gteq', 'lteq'],
                        },
                        {
                            label: '客户姓名',
                            component: 'el-input',
                            field: 'fi__customerName',
                        },


                    ],
                    onSubmit:()=>{
                        this.page = 1
                        this.getRepaymentExcessAmountList()
                    },
                    onReset: ()=> {
                        this.filters.form = {
                            fi__customerName:'',
                            de__txDate:[],
                        }
                        this.listData= {
                            count: 0,
                            data: []
                        }
                        this.getRepaymentExcessAmountList()
                    }
                },

                actions: [
                    {
                        label: '批量收息',
                        clickHandler:()=>{
                            if(this.selectedIds==''){
                                this.$message.error('请选择一条数据')
                                return false
                            }
                            this.$confirm('是否确认批量收息').then(()=> {
                                xhr.UpdateRepayWithExcessAmountInBatch(
                                    {
                                        'candidates':this.selectedIds,
                                    },
                                    res=> {
                                        try{
                                            if(res.data.status == 'success') {
                                                this.getRepaymentExcessAmountList()
                                                this.$message.success("操作成功")
                                            }else{

                                                this.$message.error(res.data.msgs[0].text)
                                            }

                                        }catch (e) {

                                            this.$message.error(error.msgs[0].text)

                                        }
                                    }
                                )
                            })
                                .catch(()=> {

                                })
                        }
                    },
                    {
                        label: '导出余额收息表',
                        clickHandler:()=>{
                            this.dialogVisible  = true
                            this.repayDate = null
                            /*if(this.filters.form.plan__repayDate){
                                let routeData = this.$router.resolve({
                                    path: '/ix/fang/repayment/reporting/RepaymentExcessAmountUse.List?format=xlsx',
                                    query: Object.assign(
                                        {
                                            pageOffset:0,
                                            pageSize:0,
                                            'xlist.search.plan.repayDate':this.filters.form.plan__repayDate,
                                            'xlist.search.plan.repayDate.dateformat':'yyyy-MM-01 00:00:00',
                                            'xlist.sort.dataField': 'de.txDate',
                                            'xlist.sort.order': 'desc'
                                        }, {}, {})
                                });
                                window.open(routeData.href.replace('#/', '/'), '_blank')

                            }else{
                                this.$alert('请填写应还款月！')
                            }*/

                        }
                    }
                ]
            }
        },
        computed : {
            filterParams: {
                get: function() {
                    return {
                        pageSize: this.pageSize,
                        pageOffset: (this.page - 1) * this.pageSize,
                        'xlist.sort.dataField': 'de.txDate',
                        'xlist.sort.order': 'desc'
                    }
                },
                set:function (newVal) {

                }
            }
        },
        watch: {
            filterParams: function () {
                this.getRepaymentExcessAmountList()
            }
        },
        mounted() {
            this.getRepaymentExcessAmountList()
        },
        methods: {
            handleSelectChange: function (val) {
                let   selectedIds = val.map(item=>item.fi__transactionId)

                this.selectedIds = selectedIds.join(',')

            },
            getRepaymentExcessAmountList: function () {
                xhr.getRepaymentExcessAmountList(
                    Object.assign({
                        'xlist.search.re.excessAmountOption' : 'None',
                        'xlist.search.re.excessAmountOption.op' : 'in',
                    }, this.filterParams, xmlBuildQuery(this.filters)),
                    res=> {
                        try {
                            this.listData = res.data
                        }catch(e){

                        }
                    })

            },
            onSubmit:function (val) {
                if(val=='true'){

                    xhr.UpdateExcessAmountOption(
                        {
                            'repayments':this.repayments,
                            'option':this.excessAmountOption,
                        },
                        res=> {
                            try{
                                if(res.data.status == 'success') {
                                    this.dialogVisible = false
                                    this.getRepaymentExcessAmountList()
                                }else{

                                    this.$message.error(res.data.msgs[0].text)
                                }

                            }catch (e) {

                                this.$message.error(error.msgs[0].text)

                            }
                        }
                    )
                }else{
                    this.dialogVisible = false
                }
            },
            exportDoc: function () {

                if(this.repayDate){
                    let routeData = this.$router.resolve({
                        path: '/ix/fang/repayment/reporting/RepaymentExcessAmountUse.List?format=xlsx',
                        query: Object.assign(
                            {
                                pageOffset:0,
                                pageSize:0,
                                'xlist.search.plan.repayDate':this.repayDate,
                                'xlist.search.plan.repayDate.dateformat':'yyyy-MM-01 00:00:00',
                                'xlist.sort.dataField': 'de.txDate',
                                'xlist.sort.order': 'desc'
                            }, {}, {})
                    });
                    window.open(routeData.href.replace('#/', '/'), '_blank')
                    this.repayDate = null
                    this.dialogVisible = false
                }else{
                    this.$alert('请填写应还款月！')
                }
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/fang/RepaymentWithExcessAmountList.vue